import { FieldType } from '@grafana/data';
import { config } from '@grafana/runtime';
import { map } from 'rxjs';
import { getCompareSeriesRefId } from '../utils/getCompareSeriesRefId.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function timeShiftQueryResponseOperator(data) {
  return data.pipe(
    map(([p, s]) => {
      const diff = s.timeRange.from.diff(p.timeRange.from);
      s.series.forEach((series) => {
        series.refId = getCompareSeriesRefId(series.refId || "");
        series.meta = __spreadProps(__spreadValues({}, series.meta), {
          timeCompare: {
            diffMs: diff,
            isTimeShiftQuery: true
          }
        });
        series.fields.forEach((field) => {
          if (field.type === FieldType.time) {
            field.values = field.values.map((v) => {
              return diff < 0 ? v - diff : v + diff;
            });
          }
          field.config = __spreadProps(__spreadValues({}, field.config), {
            color: {
              mode: "fixed",
              fixedColor: config.theme.palette.gray60
            }
          });
          return field;
        });
      });
      return __spreadProps(__spreadValues({}, p), {
        series: [...p.series, ...s.series]
      });
    })
  );
}

export { timeShiftQueryResponseOperator };
//# sourceMappingURL=timeShiftQueryResponseOperator.js.map
